import * as React from 'react'

import {
  type AnimationConfig,
  AnimationContext,
  DEFAULT_ANIMATION_CONFIG,
} from '../animation/animationContext/AnimationContext'
import { AgentBody } from './agentBody'
import { CompactLayoutProvider } from '../compactLayout'

import styles from './Agent.module.scss'

export type AgentProps = {
  renderBody: () => React.ReactNode
  renderHeader?: () => React.ReactNode
  renderFooter?: () => React.ReactNode
  animated?: boolean
  animationConfig?: AnimationConfig
}

export const Agent: React.FC<AgentProps> = ({
  renderBody,
  renderHeader,
  renderFooter,
  animated = true,
  animationConfig = DEFAULT_ANIMATION_CONFIG,
}) => {
  const headerContent = renderHeader ? <div className={styles.header}>{renderHeader()}</div> : null
  const footerContent = renderFooter ? <div className={styles.footer}>{renderFooter()}</div> : null
  return (
    <CompactLayoutProvider>
      <AnimationContext.Provider value={{ animated, config: animationConfig }}>
        <div className={styles.root}>
          {headerContent}
          <AgentBody className={styles.body}>{renderBody()}</AgentBody>
          {footerContent}
        </div>
      </AnimationContext.Provider>
    </CompactLayoutProvider>
  )
}
